import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Button } from '../button/button';
import { Icon } from '../icon/icon';
import { TagStyle } from './types/style';
const bBlock = bemClassBuilder('v-tag-block');
const bRounded = bemClassBuilder('v-tag-rounded');
export const Tag = observer(props => {
    const { id, label, color, style, buttonIconName, onClick, onButtonClick, isLoading, className } = props;
    const handleClick = () => onClick === null || onClick === void 0 ? void 0 : onClick(id);
    const handleButtonClick = (event) => {
        if (!onButtonClick)
            return;
        event.stopPropagation();
        onButtonClick(id);
    };
    const hasIcon = !!buttonIconName;
    const hasClickHandler = !!(onClick || onButtonClick);
    const b = style === TagStyle.Rounded ? bRounded : bBlock;
    return (_jsxs("div", Object.assign({ className: b.block({ color, style, hasClickHandler, hasIcon }, className), onClick: handleClick }, { children: [_jsx("span", Object.assign({ className: b.element('label') }, { children: label })), buttonIconName && (_jsx(Button, Object.assign({ className: b.element('button'), onClick: handleButtonClick, loading: isLoading, iconOnly: true }, { children: _jsx("span", Object.assign({ className: b.element('button-wrapper') }, { children: _jsx(Icon, { className: b.element('button-icon'), name: buttonIconName }) })) })))] })));
});
Tag.displayName = 'Tag';
